import { useCallback, useEffect, useState } from 'react';

import { DossierResponseDto } from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

interface FetchDossierFoResult {
  dossier: DossierResponseDto | null;
  fetchDossier: () => Promise<void>;
  fetchInProgress: boolean;
  errorOccured: boolean;
}

/**
 * Hook to get dossier with all information.
 */
export function useDossierComplet(dossierId: string): FetchDossierFoResult {
  const [dossier, setDossier] = useState<DossierResponseDto | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorOccured, setErrorOccured] = useState<boolean>(false);
  const { DossierControllerApi: dossierController } = useApi();
  const behaviourOnError = useHandleBackErrors();

  const fetchDossier = useCallback(async () => {
    setDossier(null);
    setLoading(true);
    setErrorOccured(false);

    await dossierController
      .getByIdUsingGET(dossierId)
      .then((result: DossierResponseDto) => {
        setDossier(result);
      })
      .catch((errorResponse: Response) => {
        behaviourOnError(errorResponse);
        setErrorOccured(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dossierController, dossierId, behaviourOnError]);

  useEffect(() => {
    void fetchDossier();
  }, [fetchDossier, dossierId, dossierController]);

  return {
    dossier: dossier,
    fetchInProgress: loading,
    errorOccured: errorOccured,
    fetchDossier: fetchDossier,
  };
}
